export const GlobalEventNames = {
    portalShellLoaded: 'portalShellLoaded',
    accessTokenChanged: 'accessTokenChanged',
    tenantsNotAvailable: 'tenantsNotAvailable',
    tenantChanged: 'tenantChanged',
    tenantLoaded: 'tenantLoaded',
    themeChanged: 'themeChanged',
    themeSelectChanged: 'themeSelectChanged',
    themeLoaded: 'themeLoaded',
    languageChanged: 'languageChanged',
    languageLoaded: 'languageLoaded',
    pendoInitialized: 'pendoInitialized',
    logout: 'logout',
    sessionTimedOut: 'sessionTimedOut',
    accessiblityModeChanged: 'accessiblityModeChanged',
    alertDurationChanged: 'alertDurationChanged',
    switchingOrganizations: 'switchingOrganizations',
    chatMessageReceived: 'chatMessageReceived',
    chatMessagePosted: 'chatMessagePosted',
    chatCreated: 'chatCreated',
    chatConnected: 'chatConnected',
    chatEnded: 'chatEnded',
    platformInfo: 'platformInfo',
    openApDialog: 'openApDialog',
    openServicesNav: 'openServicesNav',
    closeServicesNav: 'closeServicesNav',
    isNewNavSelected: 'isNewNavSelected',
    toggleServiceNav: 'toggleServiceNav',
};
